import { Stack, Typography, SxProps } from '@mui/material';
import { titleSX } from '@/components/blocks/DpLibrary/DpTitleCustom/style/main';
import { combineSX } from '@/utils/combineSX';

export const DpTitleCustom = ({
	title,
	sxcontainer,
	...props
}: {
	title: string;
	sxcontainer?: SxProps;
}) => (
	<Stack
		justifyContent={'center'}
		flexDirection={'row'}
		sx={combineSX([
			{ width: '100%' },
			...(Array.isArray(sxcontainer) ? sxcontainer : [sxcontainer]),
		])}
	>
		{title ? (
			<Typography component={'h1'} sx={titleSX} {...props}>
				{title}
			</Typography>
		) : null}
	</Stack>
);
